import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useContext } from 'react';
import { BubbleMenu } from '@tiptap/react';
import classNames from 'classnames';
import { Icon, Loader, Tooltip, useClasses, createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import ToolbarItem from "../ToolbarItem";
import { RichTextContext } from "../..";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Menu');
const editorFormatsMapping = {
  b: 'bold',
  i: 'italic',
  u: 'underline',
  del: 'strike',
  ol: 'orderedList',
  ul: 'bulletList'
};
var _ref2 = /*#__PURE__*/React.createElement(Loader, {
  size: "tiny"
});
const Menu = _ref => {
  var _editorContent$text, _editorContent$text2, _editorContent$text3;
  let {
    classes: classesProp,
    compactMode,
    customActions,
    editorContent,
    focused,
    handleSubmit,
    toolbar,
    toolbarStyle,
    submitTooltip,
    isBasic,
    loading,
    isSubmitDisabled
  } = _ref;
  const theme = useTheme();
  const classes = useClasses(useStyles, classesProp);
  const {
    editor,
    emoji,
    mention
  } = useContext(RichTextContext);
  const toolbarItems = useCallback(() => {
    const toolbarItemProps = {
      fixed: {
        className: classes.toolbarItem,
        classNameActive: classes.toolbarItemActive,
        color: theme.colors.actionMinor[500]
      },
      floating: {
        className: classNames(classes.toolbarItem, classes.floatingToolbarItem),
        classNameActive: classes.floatingToolbarItemActive,
        color: theme.colors.primary.white
      }
    };
    const toolbarItemStyle = compactMode ? toolbarItemProps.fixed : toolbarItemProps[toolbarStyle];
    const toolbarItems = toolbar.map(item => {
      return /*#__PURE__*/React.createElement(ToolbarItem, _extends({
        key: item.item,
        active: editor === null || editor === void 0 ? void 0 : editor.isActive(editorFormatsMapping[item.item])
      }, item, toolbarItemStyle));
    });
    if ((mention || emoji) && (toolbarStyle === 'fixed' || compactMode)) {
      toolbarItems.push(/*#__PURE__*/React.createElement("span", {
        key: "divider",
        className: classes.toolbarDivider
      }));
      if (mention) {
        toolbarItems.push(/*#__PURE__*/React.createElement(ToolbarItem, _extends({
          key: "mention",
          hint: mention.tooltip,
          item: "mention"
        }, toolbarItemStyle)));
      }
      if (emoji) {
        toolbarItems.push(/*#__PURE__*/React.createElement(ToolbarItem, _extends({
          key: "emoji",
          hint: emoji.tooltip,
          item: "emoji"
        }, toolbarItemStyle)));
      }
    }
    return toolbarItems;
  }, [classes, compactMode, editor, mention, theme, toolbar, toolbarStyle, emoji]);
  const toolbarClassNames = classNames(classes.toolbar, {
    [classes.compactMode]: compactMode && !focused,
    [classes.compactModeFocused]: compactMode && (focused || !!(editorContent !== null && editorContent !== void 0 && (_editorContent$text = editorContent.text) !== null && _editorContent$text !== void 0 && _editorContent$text.length))
  });
  if (!editor) return null;
  const submitComponent = !!(editorContent !== null && editorContent !== void 0 && (_editorContent$text2 = editorContent.text) !== null && _editorContent$text2 !== void 0 && _editorContent$text2.length) && !isSubmitDisabled ? /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    content: submitTooltip
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.submitIcon,
    onClick: handleSubmit
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "send",
    size: "large",
    color: isBasic ? theme.colors.primary.white : theme.colors.actionMajor[500],
    key: "submit"
  }))) : /*#__PURE__*/React.createElement(Icon, {
    name: "send",
    size: "large",
    color: theme.colors.textLight.disabled,
    key: "submit"
  });
  switch (true) {
    case isBasic:
      if (loading) return /*#__PURE__*/React.createElement("div", {
        className: classes.basicLoader
      }, _ref2);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(classes.basicSubmit, {
          [classes.basicSubmitClickable]: !!(editorContent !== null && editorContent !== void 0 && (_editorContent$text3 = editorContent.text) !== null && _editorContent$text3 !== void 0 && _editorContent$text3.length) && !isSubmitDisabled
        })
      }, submitComponent);
    case compactMode:
      return /*#__PURE__*/React.createElement("div", {
        className: toolbarClassNames
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.toolbarItems,
        onClick: e => e.stopPropagation()
      }, toolbarItems()), submitComponent);
    case editor && toolbarStyle === 'floating':
      return /*#__PURE__*/React.createElement(BubbleMenu, {
        tippyOptions: {
          duration: 100
        },
        editor: editor,
        className: classes.floatingToolbar
      }, toolbarItems());
    case editor && toolbarStyle === 'fixed':
      return /*#__PURE__*/React.createElement("div", {
        className: toolbarClassNames
      }, toolbarItems(), customActions && /*#__PURE__*/React.createElement("div", {
        key: "customActions",
        className: classes.toolbarCustomActions
      }, customActions));
    default:
      return null;
  }
};
export default Menu;